module.exports = __webpack_public_path__ + "static/media/edness.63e2ffa4.png";